// extracted by mini-css-extract-plugin
export default {"container":"VerticalSlider_container__iUH9k","filledBar":"VerticalSlider_filledBar__LGU9h"};